import React from 'react';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { Icon } from '@noths/polaris-design-system-core-components';

import type { DeliverySummaryViewModel } from 'src/adapters/storeToUI/adaptDeliveryToSummary';
import { DeliveryEventMessage } from 'src/components/atoms/DeliveryEventMessage/DeliveryEventMessage';
import { FreePartnerDeliveryMessage } from 'src/components/atoms/FreePartnerDeliveryMessage/FreePartnerDeliveryMessage';
import * as styles from './DeliverySummary.styles';

export interface DeliverySummaryProps extends DeliverySummaryViewModel {
  href: string;
  onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const FREE_PRICE_LABEL = 'FREE';

export const DeliverySummary = ({
  content,
  deliveryEventName,
  freePartnerDelivery,
  href,
  onLinkClick = () => {},
}: DeliverySummaryProps) => {
  return (
    <div>
      {deliveryEventName && <DeliveryEventMessage eventName={deliveryEventName} />}
      <a css={styles.deliverySummary} href={href} onClick={onLinkClick}>
        {content === null ? (
          <span css={styles.primaryLine}>
            Delivery &amp; returns info <Icon name="actionForward" size="sm" />
          </span>
        ) : (
          <>
            {content.orderByText && <small css={styles.orderBy}>{content.orderByText}</small>}
            <b css={styles.primaryLine}>
              <Icon name="delivery" size="md" />
              <span>
                {content.primary.prefix}
                {content.primary.dateTime ? (
                  <time dateTime={content.primary.dateTime}>{content.primary.value}</time>
                ) : (
                  content.primary.value
                )}{' '}
                (
                <span
                  css={content.primary.price === FREE_PRICE_LABEL ? styles.freePrice : styles.price}
                >
                  {content.primary.price}
                </span>
                )
              </span>
              {content.secondary === null && <Icon name="actionForward" size="sm" />}
            </b>
            {content.secondary && (
              <small css={styles.secondaryLine}>
                <span>
                  Want it sooner?{' '}
                  <span css={styles.fasterOption}>
                    You can get it{' '}
                    {content.secondary.dateTime ? (
                      <time dateTime={content.secondary.dateTime}>{content.secondary.value}</time>
                    ) : (
                      content.secondary.value
                    )}{' '}
                    ({content.secondary.price})
                  </span>
                </span>
                <Icon
                  color={`var(${themeVariables.colors.content.link})`}
                  name="actionForward"
                  size="sm"
                />
              </small>
            )}
          </>
        )}
      </a>
      {freePartnerDelivery && (
        <FreePartnerDeliveryMessage
          formattedThreshold={freePartnerDelivery.formattedThreshold}
          partnerName={freePartnerDelivery.partnerName}
        />
      )}
    </div>
  );
};
